import { createFeature, createReducer, on } from '@ngrx/store';

import { Counterparty } from '@shared/models';

import { CounterpartyDetailsActions } from './counterparty.actions';

export interface CounterpartyFeatureState {
  counterpartyDetails: Counterparty | null;
}

export const counterpartiesInitialState: CounterpartyFeatureState = {
  counterpartyDetails: null,
};

export const counterpartyFeature = createFeature({
  name: 'counterpartyFeature',
  reducer: createReducer(
    counterpartiesInitialState,
    on(CounterpartyDetailsActions.loadCounterpartyDetails, (state): CounterpartyFeatureState => {
      return { ...state, counterpartyDetails: null };
    }),
    on(CounterpartyDetailsActions.loadCounterpartyDetailsSuccess, (state, { counterpartyDetails }): CounterpartyFeatureState => {
      return { ...state, counterpartyDetails };
    }),
    on(CounterpartyDetailsActions.loadCounterpartyDetailsFailure, (state): CounterpartyFeatureState => {
      return { ...state, counterpartyDetails: null };
    }),
  ),
});
